// TODO: Node is fixed width because IE11 won't allow flex-calced, update when not needed anymore
// ZR: this value is related to the $sidebar-content-width variabled declared in _globals.sass
export const SIDEBAR_FIXED_WIDTH = 380;
export const STATIC_MODULE_NODE_FIXED_WIDTH = 332;
export const SEARCH_BAR_HEIGHT = 40;
const SEARCH_BAR_RIGHT_MARGIN = 12;
export const DEFAULT_MAX_NODE_WIDTH = SIDEBAR_FIXED_WIDTH - SEARCH_BAR_RIGHT_MARGIN;
const EXPANDABLE_SECTION_CARET_WIDTH = 44;
export const EXPANDABLE_SECTION_TITLE_WIDTH = SIDEBAR_FIXED_WIDTH - (EXPANDABLE_SECTION_CARET_WIDTH + SEARCH_BAR_RIGHT_MARGIN);
export const ICON_SIZE = 15;
export const BORDER_THICKNESS = 2;
export const BRANCH_LENGTH = 10;
export const SITE_TREE_NODE_MARGIN_TOP_BOTTOM = 4;
export const NODE_MAIN_TEXT_FONT_SIZE = 14;
export const NODE_COMMENT_ICON_FONT_SIZE = 12;
export const NODE_NAME_SPAN_HEIGHT = 24;
// ZR: The 14 at the end of this calculation is based on the height of the node div,
// which is based on font size. If you change font size or node name span height,
// please adjust this to match
export const DISTANCE_TO_NEXT_NODE = SITE_TREE_NODE_MARGIN_TOP_BOTTOM + 14;
export const NODE_FRAME_HEIGHT = ICON_SIZE * 2 + SITE_TREE_NODE_MARGIN_TOP_BOTTOM;
export const TREE_FRAME_MARGIN_LEFT = ICON_SIZE / 2;
export const PIXEL_OFFSET_PER_LAYER_OF_DEPTH = 20;
export const NODE_MIN_WIDTH = 150;
export const TEXT_BASED_MODULES = ['rich_text', 'header', 'text'];
export const CONTENTS_SEARCH_THROTTLE_MS = 500;
export const RENAME_MODAL_ACTION_TYPES = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE'
};
export const TRUNCATED_TOOLTIP_CHARACTER_LIMIT = 100;
export const HIDE_OR_VIEW_ICON_SIZE = 10;
export const UNEDITABLE_ICON_SIZE = 12;
export const GLOBAL_GROUP_ICON_SIZE = 14;
export const VALIDATION_ERROR_ICON_SIZE = 14;
export const CONTENTS_TAB_ACTION = 'Contents Tab Action';